import { Directive, ElementRef, forwardRef, HostListener } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive({
  selector: '[pwjCommasSeparateNumbers]',
  standalone: true,
  providers: [
    DecimalPipe,
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CommasSeparateNumbersDirective),
      multi: true,
    },
  ],
})
export class CommasSeparateNumbersDirective {
  private onChange: (value: any) => void = () => {};
  private onTouched: () => void = () => {};

  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event.target.value'])
  onInput(value: string): void {
    // remove commas and emit the raw value
    const rawValue = value.replace(/,/g, '');
    this.onChange(rawValue ? Number(rawValue) : null);

    // format the value with commas for display
    this.el.nativeElement.value = this.formatNumber(rawValue);
  }

  private formatNumber(value: string): string {
    if (!value) return '';
    const parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }

  writeValue(value: any): void {
    this.el.nativeElement.value = value
      ? this.formatNumber(value.toString())
      : '';
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.el.nativeElement.disabled = isDisabled;
  }
}
